import * as Stimulus from "@hotwired/stimulus"

export class TimeslotsController extends Stimulus.Controller {
    static get targets() {
        return ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'date', 'output'];
    }

    connect() {
        this.templates = [
            () => this.SundayTarget,
            () => this.MondayTarget,
            () => this.TuesdayTarget,
            () => this.WednesdayTarget,
            () => this.ThursdayTarget,
            () => this.FridayTarget,
            () => this.SaturdayTarget,
            () => this.SundayTarget,
        ];
    }

    showTemplateForDate(e) {
        if (!e.detail.date) {
            this.outputTarget.replaceChildren();
        } else {
            let selectedDate = new Date(e.detail.date);
            let templateToShow = this.dateTargets.find(template =>
                this.isSameDate(selectedDate, template.dataset.date)
            ) || this.templates[selectedDate.getDay()]();
            this.outputTarget.replaceChildren(templateToShow.content.cloneNode(true));
        }
    }

    isSameDate(date, value) {
        let [year, month, day] = value.split("-").map(Number);
        return date.getFullYear() === year
            && date.getMonth() === month - 1
            && date.getDate() === day;
    }
}
